import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import { apiAuth } from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";

const Register = () => {
  const nav = useNavigate();
  const { signIn } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", pw: "", referral: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.pw) return toast.error("Name, email and password required");
    setBusy(true);
    try {
      const res = await apiAuth.register({
        name: form.name, email: form.email, password: form.pw,
        referral: form.referral || undefined,
      });
      signIn(res.token, res.user);
      toast.success("Welcome to Grabb — 100 tokens 🎉");
      nav("/onboarding");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Sign-up failed");
    } finally { setBusy(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/feed";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-4 py-8" data-testid="register-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-block mb-6">
          <Logo size={40} />
        </Link>

        <div className="brutal-card p-7">
          <h1 className="font-heading font-black text-3xl mb-2">Sign up</h1>
          <p className="text-sm text-[#555555] mb-6">100 starter tokens. A unique referral code. No ads.</p>

          <button onClick={google} className="w-full brutal-btn bg-white py-3 mb-4 flex items-center justify-center gap-3" data-testid="register-google-btn">
            <svg className="w-4 h-4" viewBox="0 0 48 48">
              <path fill="#4285F4" d="M24 9.5c3.5 0 6.5 1.2 8.9 3.5l6.6-6.6C35.5 2.6 30.2.5 24 .5 14.6.5 6.6 6 2.7 14.1l7.7 6c1.9-5.5 7-9.6 13.6-9.6z"/>
              <path fill="#34A853" d="M46.1 24.5c0-1.6-.1-2.8-.4-4.1H24v8h12.6c-.5 3-2.6 5.9-5.6 7.7l7.5 5.8c4.5-4.2 7.6-10.3 7.6-17.4z"/>
              <path fill="#FBBC05" d="M10.4 28.1c-.6-1.6-.9-3.3-.9-5.1 0-1.8.3-3.5.9-5.1l-7.7-6C1 15.6 0 19.7 0 24c0 4.3 1 8.4 2.7 12.1l7.7-6z"/>
              <path fill="#EA4335" d="M24 47.5c6.3 0 11.6-2.1 15.4-5.7l-7.5-5.8c-2.1 1.4-4.7 2.2-7.9 2.2-6.6 0-12.2-4.4-14.2-10.4l-7.7 6C6.6 42 14.5 47.5 24 47.5z"/>
            </svg>
            <span className="text-sm">Continue with Google</span>
          </button>

          <div className="flex items-center gap-3 my-4">
            <div className="flex-1 h-px bg-[#E0E0E0]" />
            <span className="text-xs text-[#555555] font-mono">OR</span>
            <div className="flex-1 h-px bg-[#E0E0E0]" />
          </div>

          <form onSubmit={submit} className="space-y-3">
            <Field label="Name" value={form.name} onChange={(v) => setForm({ ...form, name: v })} testid="register-name" />
            <Field label="Email" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} testid="register-email" />
            <Field label="Password" type="password" value={form.pw} onChange={(v) => setForm({ ...form, pw: v })} testid="register-password" />
            <Field label="Referral code (optional)" value={form.referral} onChange={(v) => setForm({ ...form, referral: v })} placeholder="LUKE8F3A" testid="register-referral" />
            <button type="submit" disabled={busy} className="w-full brutal-btn bg-[#FF6A2C] text-white py-3 mt-2 disabled:opacity-60" data-testid="register-submit">
              {busy ? "Creating…" : "Create account"}
            </button>
          </form>

          <p className="text-sm text-center text-[#555555] mt-5">
            Already on Grabb?{" "}
            <Link to="/login" className="font-bold text-[#0A0A0A] underline" data-testid="register-to-login">
              Log in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

const Field = ({ label, value, onChange, type = "text", placeholder, testid }) => (
  <div>
    <label className="label-mono block mb-1.5">{label}</label>
    <input type={type} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="brutal-input" data-testid={testid} />
  </div>
);

export default Register;
